import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Command } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { DwellingService } from '../data/dwelling.service';
import { rentalObjectCommand } from '../../command/rental-object.command';

@Injectable()
export class PrintStairCaseListCommandHandler implements ICommandHandler {
  constructor(
    private _dataService: DwellingService,
    private _nativeWindow: NativeWindowService
  ) {}

  canExecute(command: Command): boolean {
    return command.id === rentalObjectCommand.showStairCaseList && command.context;
  }

  /*
  execute(command: Command): Observable<void> {
    return this._dataService.printStairCaseList(command.context.id).pipe(map(
      res => this._nativeWindow.openFile(res)));
  }
  */

  execute(command: Command): Observable<void> {
    return this._dataService.printStairCaseList(command.context.id).pipe(
      map(file => {
        this._nativeWindow.save(file);
      })
    );
  }
}
